import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrud = () => import('./staff/crud')
const ViewStaffView = () => import('./staff/view')

Vue.use(Router)

const router =
  [
    {
      path: '/st/customers',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'CustomerDashboardStaff',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Clientes',
          }          
        },        
        {
          path: 'customers',
          name: 'CustomerListStaff',
          component: ViewStaffCrud,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Listado Clientes',
          }                    
        },       
        {
          path: 'customers/:customersID/view',
          name: 'CustomerViewStaff',
          component: ViewStaffView,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Vista Cliente',
          }
        },
      ]
    },

    {
      path: '/cu/customers',
      component: DefaultContainer,
      children: [
        
      ]
    },

    {
      path: '/su/customers',
      component: DefaultContainer,
      children: [
        
      ]
    },    
  ]

export default router
